export default "__VITE_ASSET__BqEIl9XI__"